import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener("input", this.restrict.bind(this))
    this.element.addEventListener("blur", this.formatOnBlur.bind(this))
  }

  disconnect() {
    this.element.removeEventListener("input", this.restrict.bind(this))
    this.element.removeEventListener("blur", this.formatOnBlur.bind(this))
  }

  restrict() {
    const input = this.element
    const pos = input.selectionStart
    let val = input.value

    let hasDecimal = false
    let cleaned = ""
    for (const ch of val) {
      if (/\d/.test(ch)) {
        cleaned += ch
      } else if (ch === "." && !hasDecimal) {
        cleaned += ch
        hasDecimal = true
      }
    }

    cleaned = cleaned.replace(/^0+(\d)/, "$1")

    if (cleaned !== val) {
      input.value = cleaned
      input.setSelectionRange(Math.min(pos, cleaned.length), Math.min(pos, cleaned.length))
    }
  }

  formatOnBlur() {
    const val = this.element.value
    if (val === "" || val === ".") {
      this.element.value = ""
      return
    }
    const num = parseFloat(val)
    if (!isNaN(num)) {
      this.element.value = num.toFixed(2)
    }
  }
}
